import { memo, useEffect } from 'react'
import { NavigateFunction } from 'react-router-dom'
import { observer } from 'mobx-react'
import { Experiments } from 'OptimizelyProvider'
import useDecision from 'utils/tracking/optimizely/useDecision'
import { isInABTestLoadingPageVariantB } from 'utils/tracking/sitespect/campaigns'
import { useRootStore } from 'stores/utils/hooks/useRootStore'

export enum AbTestsType {
  SITESPECT,
  OPTIMIZELY
}

interface ConditionallyStepSkipperProps {
  navigate: NavigateFunction
  abTestType: AbTestsType
}

const ConditionallyStepSkipper = observer(
  ({ abTestType }: ConditionallyStepSkipperProps) => {
    const {
      rootStore: {
        page: { setIsLoadingLeadHiddenForExperiment }
      }
    } = useRootStore()

    const decisionResult = useDecision(Experiments.CAT_1043_REMOVE_LOADING_PAGE)
    const variationKey = decisionResult?.[0].variationKey

    const isOptimizelyVariantUsed =
      abTestType === AbTestsType.OPTIMIZELY && variationKey === 'variation_2'

    const isSitespectVariantUsed =
      abTestType === AbTestsType.SITESPECT && isInABTestLoadingPageVariantB()

    useEffect(() => {
      if (isSitespectVariantUsed || isOptimizelyVariantUsed) {
        setIsLoadingLeadHiddenForExperiment(true)
      }
    }, [
      setIsLoadingLeadHiddenForExperiment,
      isSitespectVariantUsed,
      isOptimizelyVariantUsed
    ])

    return null
  }
)

export default memo(ConditionallyStepSkipper)
